import { Button, Grid, Icon, Typography, useMediaQuery } from "@mui/material";
import React, { Fragment, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import FieldFormComponent from "../components/fieldForm/FieldForm.component";
import { addFieldData } from "../store/actions/fields.actions";
import {
  fetchThingRequest,
  resetThingState,
} from "../store/actions/thing.actions";
import { v4 as uuidv4 } from "uuid";

const FieldAddPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("(max-width: 767px");
  const [formValues, setFormValues] = useState(null);

  const { success, data } = useSelector((state) => state.thing);

  const onSubmit = (values) => {
    setFormValues(values);
    const uniqueId = uuidv4().replace(/-/g, "").substring(0, 8);
    const thingBody = {
      fieldName: values.label,
      username: uniqueId,
      environment: "test",
    };
    dispatch(fetchThingRequest(thingBody));
  };

  useEffect(() => {
    if (success && data) {
      const formValuesWithThing = {
        ...formValues,
        id_thing: data?.data?.thingId,
      };
      dispatch(addFieldData(formValuesWithThing));
      navigate(-1);
      dispatch(resetThingState());
    }
  }, [data, success, dispatch, formValues, navigate]);

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <Fragment>
      <div style={{ display: "flex", alignItems: "center" }}>
        <Button onClick={handleGoBack}>
          <Icon>arrow_back</Icon>
        </Button>
        <h3>{t("fields-add-page.title")}</h3>
      </div>
      <Grid
        container
        rowSpacing={2}
        columnSpacing={{ xs: 1, sm: 2, md: 3 }}
        sx={{ marginBottom: "20px" }}
      >
        {isMobile ? null : (
          <Grid item xs={12} sm={9} md={9}>
            <Typography>
              <span>{t("fields-add-page.subtitle")}</span>
            </Typography>
          </Grid>
        )}
        <Grid item xs={3}></Grid>
      </Grid>

      <div style={{ marginBottom: "80px" }}>
        <FieldFormComponent
          addNew={true}
          onSubmit={onSubmit}
        ></FieldFormComponent>
      </div>
    </Fragment>
  );
};

export default FieldAddPage;
